import { LogoMark } from "./LogoMark";

export const Wordmark = ({ light = false, className = "text-[20px]", markClass = "h-10 w-auto" }) => (
  <span className="inline-flex shrink-0 items-center gap-2.5 whitespace-nowrap">
    <LogoMark light={light} className={markClass} />
    <span className={`font-logo font-bold tracking-tight ${light ? "text-white" : "text-[#133a48]"} ${className}`}>Stop Cheni</span>
  </span>
);

export const Logo = ({ light = false, testId = "logo", href = "/" }) => (
  <a href={href} data-testid={testId} className="group flex shrink-0 items-center" aria-label="Stop Cheni – accueil">
    <Wordmark light={light} />
  </a>
);
